export const PUSH_COLORS = 'PUSH_COLORS' as 'PUSH_COLORS'
